import { render, staticRenderFns } from "./PreguntaPrevioPasoParcelas.vue?vue&type=template&id=15c4020b"
import script from "./PreguntaPrevioPasoParcelas.vue?vue&type=script&lang=js"
export * from "./PreguntaPrevioPasoParcelas.vue?vue&type=script&lang=js"
import style0 from "./PreguntaPrevioPasoParcelas.vue?vue&type=style&index=0&id=15c4020b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports